import React from "react";

import { MarginaliaGroup } from "../../../components/ContentBuilder/MarginaliaGroup/MarginaliaGroup";
import { MarginaliaTitle } from "../../../components/ContentBuilder/MarginaliaTitle/MarginaliaTitle";
import { MarginaliaButton } from "../../../components/ContentBuilder/MarginaliaButton/MarginaliaButton";
import { MarginaliaList } from "../../../components/ContentBuilder/MarginaliaList/MarginaliaList";
import { MarginaliaData } from "../../../components/ContentBuilder/ContentBuilder.type";

import { downloadTopicPdf } from "./downloadFile";

// Topic PDF in public/files/pdf; the download button is hidden while this is undefined.
const TOPIC_PDF_FILENAME: string | undefined = "applia-home-appliance-monitor-2025-use-and-consumption.pdf";

export const useAndConsumptionPageMarginalia: MarginaliaData = {
	component: MarginaliaGroup,
	props: {
		children: [
			<MarginaliaTitle key="on-this-page-title" title="On this page" />,
			<MarginaliaList
				key="on-this-page-list"
				items={[
					{
						label: "Increase in energy efficient products",
						scrollTo: "use-and-consumption-energy-efficient-products",
					},
					{
						label: "Average water and energy consumption",
						scrollTo: "use-and-consumption-water-dual-chart",
					},
					{
						label: "Evolution of energy consumption and energy prices",
						scrollTo: "use-and-consumption-evolution-energy-visual",
					},
					{
						label: "Change in energy prices and consumption",
						scrollTo: "use-and-consumption-energy-prices-eu",
					},
					{
						label: "Energy savings",
						scrollTo: "use-and-consumption-savings-area",
					},
					{
						label: "Repair of home appliances",
						scrollTo: "repair-of-home-appliances-header",
					},
				]}
			/>,
			<div key="topic-download-spacer" className="mt-3">
				<MarginaliaTitle title="Topic download" />
			</div>,
			...(TOPIC_PDF_FILENAME ? [<MarginaliaButton key="download" variant="download" icon="document" label="Use and consumption" sublabel="PDF" onClick={() => downloadTopicPdf(TOPIC_PDF_FILENAME)} />] : []),
			<MarginaliaButton key="copy" variant="copy" label="Copy link to this topic" clickedLabel="Link copied" onClick={() => navigator.clipboard.writeText(window.location.href)} />,
		],
	},
};
